import { faClose, faStopwatch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import useTranslation from "../../hooks/useTranslation";
import { PlatformMobile } from "../../helpers/Constants";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogAccesoVascular = ({
  icon,
  text,
  callbackConfirm,
  callbackCancel,
  status,
}) => {
  const T = useTranslation();
  const [isOpen, setIsOpen] = useState(status);
  const handlerClose = () => {
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handlerOnConfirm = () => {
    if (callbackConfirm) {
      callbackConfirm();
    }
  };

  useEffect(() => {
    setIsOpen(status);
  }, [status]);

  return (
    <>
      <FloatingDialog isOpen={isOpen} onClose={handlerClose} noBackground>
        <div
          style={{
            gap: PlatformMobile ? "10px" : "32px",
            padding: PlatformMobile ? "12px" : "32px",
          }}
          className="flex flex-col w-full h-full items-center justify-center"
        >
          {icon && (
            <div className="rounded flex items-center justify-center text-xl bg-[#2aac9c] w-8 h-8 text-white border">
              <FontAwesomeIcon icon={faStopwatch} />
            </div>
          )}
          <span
            style={{
              maxWidth: PlatformMobile ? "80vw" : "430px",
              width: PlatformMobile ? "80vw" : "430px",
            }}
            className="font-bold text-center text-base  text-[24px]"
          >
            {T(text)}
          </span>
          <div className="flex flex-wrap justify-center gap-4 w-full max-w-[450px]">
            <SimpleButton
              onClick={handlerClose}
              text={T("No")}
              variant="gray"
            />
            <SimpleButton onClick={handlerOnConfirm} text={T("yes")} />
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogAccesoVascular;
